var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUpload = function SvgIconUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_upload_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_upload_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M5.494 16c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 0 1 4 14.5v-.75c0-.213.071-.39.214-.534A.72.72 0 0 1 4.746 13c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534v.75h9v-.75c0-.213.072-.39.214-.534a.72.72 0 0 1 .532-.216c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534v.75c0 .412-.147.766-.44 1.06-.295.293-.648.44-1.06.44H5.493ZM9.25 5.875 7.583 7.542a.73.73 0 0 1-.53.229.762.762 0 0 1-.542-.23.745.745 0 0 1 .01-1.062l2.958-2.958a.756.756 0 0 1 .525-.208c.1 0 .194.017.281.052a.69.69 0 0 1 .236.156l2.958 2.958c.153.153.23.327.23.521a.733.733 0 0 1-.22.52.762.762 0 0 1-.541.23.729.729 0 0 1-.531-.23L10.75 5.876v6.375c0 .213-.072.39-.214.534a.72.72 0 0 1-.532.216.734.734 0 0 1-.535-.216.72.72 0 0 1-.219-.534V5.875Z"
  }))));
};
export default SvgIconUpload;